import { BaseRepository } from './BaseRepository';
import { ExperienceStateType, RoundPurposeType, TargetDeviceType } from '../entity/PortfolioReportItem';
const queryString = require('query-string');

export class PortfolioReportRepository extends BaseRepository {
  public getPortfolioReport(goalId: string): Promise<any> {
    return this.httpClient.get(`/v2/project_portfolio/goals/${goalId}/report`).then((res: any) => res.data.data);
  }

  public getTargetDeviceFiltersFromUrl(): TargetDeviceType[] {
    return this.getFiltersFromUrl('targetDevice');
  }

  public getStateFiltersFromUrl(): ExperienceStateType[] {
    return this.getFiltersFromUrl('state');
  }

  public getRoundPurposeFiltersFromUrl(): RoundPurposeType[] {
    return this.getFiltersFromUrl('roundPurpose');
  }

  private getFiltersFromUrl(key: string) {
    const query = queryString.parse(window.location.search);
    return typeof query[key] === 'object' ? Array.from(query[key]) : typeof query[key] === 'string' ? [query[key]] : [];
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/domain/repository/PortfolioReportRepository.ts